import React from "react";
import {Box, Button, Typography} from "@mui/material";

export const SaveTrendButton = (
    {handleSubmit, queryString, mt = 1}:
        {
            handleSubmit: (e: any, queryString: string) => void,
            queryString: string,
            mt?: number,
        }
) => {

    return (
        <Box
            display="flex"
            flexDirection="row"
            justifyContent="center"
            mt={mt}
        >
            <Button
                onClick={(e:any) => handleSubmit(e, queryString)}
                variant='outlined'
                sx={{
                    textTransform: 'none'
                }}
            >
                <Typography
                    variant="caption"
                >
                    Save Trend
                </Typography>

            </Button>
        </Box>
    )
}